import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ showContactModal: boolean }>;

export const DispatchShowContactModal: HandlerType = props => {
    props.dispatch?.({
        type: "Pages/AnnualReturnsOrder/ShowContactModal",
        showContactModal: props.parameter.showContactModal,
    } as any);
};

export const chain = [DispatchShowContactModal];

const showContactModal = createHandlerChainRunner(chain, "ShowContactModal");
export default showContactModal;
